




















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { IUser, ISprint, IEpic, IIssueType, ICustomer } from '@/lib/interfaces';
import { IssueSelectType } from '@/lib/enums';
import moment from 'moment';
import vSelect from 'vue-select';
import { getAllUsers, getAllCustomers, getAllSprints, getAllEpics, getAllIssueTypes } from '@/services/api.service';
import IssueTypeOption from '@/components/select/IssueTypeOption.vue';
import EpicOption from '@/components/select/EpicOption.vue';
import UserOption from '@/components/select/UserOption.vue';
import SprintOption from '@/components/select/SprintOption.vue';

@Component({
  components: {
    'v-select': vSelect,
    IssueTypeOption,
    EpicOption,
    UserOption,
    SprintOption,
  },
})
export default class SupSelect extends Vue {
  private response: Map<string, IUser | ICustomer | ISprint | IEpic | IIssueType> = new Map();

  @Prop() private type!: IssueSelectType;
  @Prop() private project!: string;
  @Prop({ default: '' }) private value!: string;
  @Prop({ default: () => [] }) private disableOptions!: string[];

  private async created() {
    let response: Array<IUser | ICustomer | ISprint | IEpic | IIssueType> = [];
    switch (this.type) {
      case IssueSelectType.users:
        response = await getAllUsers({ roles: ['project_employee'] });
        break;
      case IssueSelectType.managers:
        // response = await getAllUsers({roles: ['project_manager']});
        response = await getAllUsers();
        break;
      case IssueSelectType.customers:
        response = await getAllCustomers();
        break;
      case IssueSelectType.sprints:
        response = await getAllSprints(this.project);
        break;
      case IssueSelectType.epics:
        response = await getAllEpics(this.project);
        break;
      case IssueSelectType.types:
        response = await getAllIssueTypes();
        break;
      default:
        break;
    }
    this.response = response.reduce((res: SupSelect['response'], cur) => {
      res.set(cur._id!, cur);
      return res;
    }, new Map());
  }

  private get options(): string[] {
    const res: string[] = [];
    for (const key of this.response.keys()) {
      if (!this.disableOptions.includes(key)) {
        res.push(key);
      }
    }
    return res;
  }

  private onChange(value: string) {
    if (value !== this.value) {
      this.$emit('change', value);
    }
  }

  private createOption(id: string): IUser | ICustomer | ISprint | IEpic | IIssueType | undefined {
    return this.response.get(id);
  }
}
